import { useEffect, useState } from 'react'
import useAxios from '../../hooks/useAxios'
import { PaginationResponseInterface } from '../../types/pagination'
import SelectSearchMultiple, { IOptionSelect } from '../SelectSearchMultiple'
import SelectSearch from '.'
import { IAddress } from '../../types/address'

interface Props {
  handleFilterChange?: (filter: any) => void
  selected?: string[]
  onSelect: (e: any) => void
  resetAutoComplete?: string
  label?: string
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  helperText?: string | any
  error?: boolean | any
  name?: string
}

const AddressSelectSearch = (props: Props) => {
  const {
    handleFilterChange,
    selected,
    onSelect,
    resetAutoComplete = '',
    label = 'เลือกที่อยู่',
    ...rest
  } = props
  const [search, setSearch] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [debouncedSearch, setDebouncedSearch] = useState<string>(search)

  const { data, isLoading } = useAxios<PaginationResponseInterface<IAddress>>({
    method: 'GET',
    url: '/address',
    params: {
      page: 1,
      perPage: 15,
      search: debouncedSearch,
      startDate: '',
      endDate: '',
    },
  })

  useEffect(() => {
    setLoading(true)
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
      setLoading(false)
    }, 1000)

    return () => {
      clearTimeout(handler)
      setLoading(false)
    }
  }, [search])

  const handleSearch = async (value: string) => {
    setSearch(value)
  }

  const currentLoadingState = loading || isLoading

  return (
    <>
      <SelectSearch<IAddress>
        {...rest}
        loading={currentLoadingState}
        resetAutoComplete={resetAutoComplete}
        label={`${label} ${currentLoadingState ? 'กำลังโหลด...' : ''}`}
        onSelect={onSelect}
        search={search}
        onSearch={handleSearch}
        options={
          data?.records.map((address: IAddress) => ({
            label: `${address.name} โทร.${address.phoneNumber}, ${address.address} ${address.subDistrict} ${address.district} ${address.province} ${address.postcode}`,
            value: address,
          })) || ([] as IOptionSelect<any>[])
        }
      />
    </>
  )
}

export default AddressSelectSearch
